import { useCallback } from 'react';
import { exitGame } from '@/utilities/helpers/exitGame';
import { useGameLifecycleTracking } from '@/routes/Home/useGameLifecycleTracking';

export const useExitGame = () => {
  const { fireGameExit } = useGameLifecycleTracking();

  return useCallback(
    (url?: string) => {
      fireGameExit();
      exitGame(url);
    },
    [fireGameExit],
  );
};
